import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { X } from "lucide-react";

export default function StaffUploadDialog({ exercise, student, sub, onClose, onDone }) {
  const [text, setText] = useState(sub?.text || "");
  const [kept, setKept] = useState((sub?.files || []).map((f) => f.id));
  const [files, setFiles] = useState([]);
  const mut = useMutation({
    mutationFn: async () => {
      const fd = new FormData();
      fd.append("text", text);
      fd.append("keep_file_ids", kept.join(","));
      files.forEach((f) => fd.append("files", f));
      return (await api.post(`/exercises/${exercise.id}/submit-for/${student.id}`, fd)).data;
    },
    onSuccess: () => { toast.success("Consegna caricata per lo studente"); onDone(); },
    onError: (e) => toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Errore caricamento file"),
  });
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="staff-upload-dialog">
        <DialogHeader>
          <DialogTitle>Carica consegna · {student.name}</DialogTitle>
          <DialogDescription>{exercise.title} — la consegna risulterà caricata dalla segreteria.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {(sub?.files || []).filter((f) => kept.includes(f.id)).map((f) => (
            <div key={f.id} className="flex items-center justify-between text-xs px-2 py-1.5 rounded bg-stone-50 border border-stone-200">
              <span className="truncate">{f.filename}</span>
              <button onClick={() => setKept(kept.filter((k) => k !== f.id))} data-testid={`staff-upload-remove-${f.id}`}><X className="w-3.5 h-3.5"/></button>
            </div>
          ))}
          <input type="file" multiple onChange={(e) => { const list = Array.from(e.target.files || []); const big = list.find((f) => f.size > 50 * 1024 * 1024); if (big) { toast.error(`${big.name}: file troppo grande (max 50 MB)`); e.target.value = ""; setFiles([]); } else { setFiles(list); } }} className="block w-full text-sm" data-testid="staff-upload-files"/>
          <p className="text-[11px] text-stone-500">PDF, foto (anche iPhone), Word, Excel, audio, video · max 50 MB per file</p>
          <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="Testo della consegna (facoltativo)" data-testid="staff-upload-text"/>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose} data-testid="staff-upload-cancel">Annulla</Button>
            <Button className="bg-[#1C352D] hover:bg-[#14271f]" disabled={mut.isPending || (!files.length && !kept.length && !text.trim())} onClick={() => mut.mutate()} data-testid="staff-upload-submit">
              {mut.isPending ? "Caricamento…" : "Carica consegna"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
